module.exports = __webpack_public_path__ + "img/medium-stop.f61ef448.svg";